<script setup lang="ts">
</script>
    
<template>
<button class="button" type="button">
  <slot></slot>
</button>
</template>
    
<style scoped lang="scss">
@import "@/assets/sass/app2.scss";
.button {
 display: inline-block;
 padding: 8px 24px;
 border: 1px solid $green-1;
 border-radius: 4px;
 transition: all 0.2s ease-in;
 position: relative;
 overflow: hidden;
 font-size: 19px;
 color: $green-1;
 z-index: 1;
 background-color: rgba($color: #ffffff, $alpha: 1.0);
}

.button:before {
 content: "";
 position: absolute;
 left: 50%;
 transform: translateX(-50%) scaleY(1) scaleX(1.25);
 top: 100%;
 width: 140%;
 height: 180%;
 border-radius: 50%;
 display: block;
 transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
 z-index: -1;
}

.button:after {
 content: "";
 position: absolute;
 left: 55%;
 transform: translateX(-50%) scaleY(1) scaleX(1.45);
 top: 180%;
 width: 160%;
 height: 190%;
 background-color: $green-1;
 border-radius: 50%;
 display: block;
 transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
 z-index: -1;
}

.button:hover {
 color: #ffffff;
 border: 1px solid $green-1;
}

.button:hover:before {
 top: -35%;
 background-color: $green-1;
 transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
}

.button:hover:after {
 top: -45%;
 background-color: $green-1;
 transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
}
</style>